import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import {
    FundingSource,
    FundingSourceSingle,
    Staff,
    SingleStaff,
    Client,
    ClientSingle,
    AuthUtilization,
    System,
    Schedule,
    ClaimDetails,
    Invoices,
    InvoiceDetails,
    Report,
    TimeSheetDetailPage,
    Analytic,
    Claims,
    BillingOverview,
    Forms,
    CreateForm,
    TimeSheet,
    Resource,
    Dashboard,
    ResourceById,
    CompletedClaims,
    ClaimPayments,
    ClaimPaymentDetail,
    Library,
    ProgressReportBuilder,
    Supervision,
    Tasks,
    ReleaseNotesPage,
    TutorialVideos,
    Wishlist,
    ClinicalSettings,
} from 'pages';
import { OrgIntegrations, PermissionList, RolePermission } from '../utils';
import { ManualSession, Session } from '../fragments';
import { SavedFiltersGate } from './savedFiltersGate';

export const Router = () => {
    const { cSession } = OrgIntegrations();

    return (
        <SavedFiltersGate>
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/release-notes" element={<ReleaseNotesPage />} />
                {/* Help Center → Tutorial Videos. Viewing is ungated on purpose —
                    authoring is what TUTORIAL_VIDEO_MANAGE gates, inside the page. */}
                <Route path="/tutorial-videos" element={<TutorialVideos />} />
                {/* Sidebar support block → Wishlist. Ungated: every staff user can file and read their
                    org's requests; the api enforces requester-only edits. */}
                <Route path="/wishlist" element={<Wishlist />} />

                <Route path="/dashboard" element={<Dashboard />} />

                {RolePermission([PermissionList.FS_LIST_READ?.code]) && <Route path="/fundingSource" element={<FundingSource />} />}
                {RolePermission([PermissionList.FS_READ?.code]) && <Route path="/fundingSource/:id" element={<FundingSourceSingle />} />}

                {RolePermission([PermissionList.STAFF_LIST_READ.code, PermissionList.STAFF_CONNECTED_LIST_READ.code]) && (
                    <Route path="/staff" element={<Staff />} />
                )}

                {/*{RolePermission([PermissionList.STAFF_READ.code]) && <Route path="/staff/:id" element={<SingleStaff />} />}*/}
                <Route path="/staff/:id" element={<SingleStaff />} />
                {RolePermission([PermissionList.STAFF_READ.code]) && <Route path="/staff/:id/success" element={<SingleStaff />} />}
                {RolePermission([PermissionList.STAFF_READ.code]) && <Route path="/staff/:id/forbidden" element={<SingleStaff />} />}

                {RolePermission([PermissionList.CLIENT_LIST_READ?.code, PermissionList.CONNECTED_CLIENT_READ?.code]) && (
                    <Route path="/client" element={<Client />} />
                )}
                {RolePermission([PermissionList.CLIENT_AUTHORIZATION_READ?.code, PermissionList.CLIENT_AUTHORIZATION_MANAGE?.code]) && (
                    <Route path="/client/authorization-utilization" element={<AuthUtilization />} />
                )}
                {RolePermission([PermissionList.CLIENT_READ?.code]) && <Route path="/client/:id" element={<ClientSingle />} />}
                {RolePermission([
                    PermissionList.COMPANY_PROFILE_MANAGE.code,
                    PermissionList.ROLES_READ.code,
                    PermissionList.SYSTEM_SERVICE_TYPES?.code,
                    PermissionList.SYSTEM_CREDENTIALS?.code,
                    PermissionList.SYSTEM_DEPARTMENTS?.code,
                    PermissionList.SYSTEM_JOB_TITLES?.code,
                    PermissionList.SYSTEM_PAYCODE_TYPES?.code,
                    PermissionList.SYSTEM_MILEAGE?.code,
                    PermissionList.SYSTEM_OVERTIME?.code,
                    PermissionList.SYSTEM_PLACE_OF_SERVICE?.code,
                    PermissionList.MANAGE_INTEGRATIONS?.code,
                ]) && <Route path="/practice-settings/*" element={<System />} />}

                {cSession &&
                    RolePermission([
                        PermissionList.DOMAIN_CREATE?.code,
                        PermissionList.DOMAIN_READ?.code,
                        PermissionList.SYSTEM_SERVICE_TYPES?.code,
                    ]) && <Route path="/clinical-settings" element={<ClinicalSettings />} />}

                <Route path="/schedule" element={<Schedule />} />

                {RolePermission([PermissionList.TASK_MANAGE?.code, PermissionList.TASK_FULL_ACCESS?.code]) && (
                    <Route path="/tasks" element={<Tasks />} />
                )}

                {RolePermission([
                    PermissionList.CLAIMS_READ?.code,
                    PermissionList.CLAIM_PMT_READ?.code,
                    PermissionList.INVOICE_READ?.code,
                ]) && <Route path="/overview" element={<BillingOverview />} />}

                {RolePermission([PermissionList.CLAIMS_READ?.code]) && <Route path="/claims" element={<Claims />} />}

                {/*{RolePermission([PermissionList.CLAIMS_READ?.code]) && <Route path="/completed-claims" element={<CompletedClaims />} />}*/}

                {/*{RolePermission([PermissionList.CLAIMS_READ?.code]) && <Route path="/claim/:id" element={<ClaimDetails />} />}*/}
                {/*{RolePermission([PermissionList.CLAIMS_READ?.code]) && <Route path="/billedClaim/:id" element={<ClaimDetails />} />}*/}
                {/*{RolePermission([PermissionList.CLAIMS_READ?.code]) && <Route path="/completed-claim/:id" element={<ClaimDetails />} />}*/}

                {RolePermission([PermissionList.INVOICE_READ?.code]) && <Route path="/invoices" element={<Invoices />} />}
                {RolePermission([PermissionList.INVOICE_READ?.code]) && <Route path="/invoice/:id" element={<InvoiceDetails />} />}

                {RolePermission([PermissionList.CLAIM_PMT_READ?.code]) && <Route path="/claimPayments" element={<ClaimPayments />} />}

                <Route path="/claim-payment/:id" element={<ClaimPaymentDetail />} />

                {RolePermission([PermissionList.REPORT_MANAGE?.code]) && <Route path="/report" element={<Report />} />}
                <Route path="/analytic" element={<Analytic />} />

                {RolePermission([PermissionList.PAYROLL_READ?.code, PermissionList.PAYROLL_MANAGE?.code]) && <Route path="/timesheet" element={<TimeSheet />} />}
                {RolePermission([PermissionList.PAYROLL_READ?.code, PermissionList.PAYROLL_MANAGE?.code]) && <Route path="/timesheet/:id" element={<TimeSheetDetailPage />} />}

                <Route path="/resource" element={<Resource />} />
                <Route path="/resource/:id" element={<ResourceById />} />

                {RolePermission([PermissionList.MANAGE_CUSTOM_FORM.code]) && <Route path="/templates" element={<Forms />} />}
                {/*{RolePermission([PermissionList.MANAGE_CUSTOM_FORM.code]) && <Route path="/create-form" element={<CreateForm />} />}*/}
                {RolePermission([PermissionList.MANAGE_CUSTOM_FORM.code]) && <Route path="/template/:id" element={<CreateForm />} />}

                <Route path="/progress-report/:id/client/:clientId" element={<ProgressReportBuilder />} />
                <Route path="/progress-report/:id/client/:clientId/report/:reportId" element={<ProgressReportBuilder />} />

                {/*{RolePermission([PermissionList.FS_SERVICE_READ?.code]) &&*/}
                {/*    <Route path="/supervision" element={<Supervision />} />*/}
                {/*}*/}

                {RolePermission([PermissionList.GOAL_READ.code]) && cSession && <Route path="/library" element={<Library />} />}

                <Route path="/appointment/:apptId/session/:sessionId" element={<Session />} />

                {cSession && RolePermission([PermissionList.SESSION_DATA_MANAGE.code]) && (
                    <Route path="/client/:id/manual-data" element={<ManualSession />} />
                )}

                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </SavedFiltersGate>
    );
};
